module.exports = __webpack_public_path__ + "assets/logo_sq_colored-d36186.svg";